/**
 * Mock category data for now, for static generation
 * Source navigation_categories in udemy/browse/context_processors.py
 * need to provide slug url instead of absolute url.
 */
import {udemyApi} from 'src/lib/ud-global-fetch';

export async function getCourseData(courseId: number) {
    try {
        const response = await udemyApi.get(
            `/courses/${courseId}/?fields[course]=title,context_info,avg_rating_recent,visible_instructors,num_subscribers,num_reviews,image_304x171,tracking_id`,
        );

        return await response.data;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(
            `Error fetching category context data from monolith with slug: ${courseId}. Error: ${JSON.stringify(
                error,
            )}`,
        );
        throw error;
    }
}
